
	import { defineComponent, PropType } from 'vue';

	import LoadingSpinner from '@/ChildrenComponents/LoadingSpinner.vue';
	import IncorrectPermissions from '@/ChildrenComponents/IncorrectPermissions.vue';
	import FiscalYearReportSearch from '@/ChildrenComponents/Reports/FiscalYearReportSearch.vue';
	import FiscalYearReportTable from '@/ChildrenComponents/Reports/FiscalYearReportTable.vue';

	import { ComponentType } from '@/Enums/ComponentType';

	import { IInternalUser } from '@/Models/IInternalUser';
	import { IFiscalYearReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

    import { doesUserRoleHaveComponentViewPermissions } from '@/Services/Helper/component-permissions-helper';

	import { useUserStore } from '@/Services/Store/user-store';

	export default defineComponent({
		name: 'fiscal-year-report',
		components: { LoadingSpinner, IncorrectPermissions, FiscalYearReportSearch, FiscalYearReportTable },
		props: {
			title: { type: String, required: true },
			filename: { type: String, required: true },
			isSearching: { type: Boolean, required: true },
			reportData: { type: Object as PropType<IFiscalYearReport[]>, required: true },
			headers: { type: Object as PropType<IDataTableHeader[]>, required: true },
			totalColumnTitle: { type: String, required: false, default: "Total" },
		},
		emits: ["search"],
		setup(): { currentUser: IInternalUser | null } {
			const userStoreInstance = useUserStore();
			return { currentUser: userStoreInstance.$state.cstInternalUser };
		},
		data () {
			return {
				isLoading: false,
			}
		},
		methods: {
			search(searchDto: IFiscalYearReportSearch) {
				this.$emit("search", searchDto);
			}
		},
		computed: {
			canView(): boolean {
				return doesUserRoleHaveComponentViewPermissions(this.currentUser?.attachedRoles ?? [], ComponentType.Report);
			},
		},
	});
